module.exports = __webpack_public_path__ + "img/championship-bg.aaba32ca.jpg";